<template lang="pug">
    el-tree(
      node-key="id",
      accordion,
      show-checkbox,
      @check="check",
      :data="treeData",
      :props="defaultProps",
      @check-change="checkChange",
      @node-click="handleNodeClick",
      :default-expand-all="true",
      @current-change="currentChange",
      :default-checked-keys="defaultCheckedKeys",
      :class="'public-tree-component'"
    )
      span(:class="{ 'custom-tree-node': true, 'caonima': node.data.count }" slot-scope="{ node, data }")
        span(:class="{ customClassHasId: node.data.name }")
          span(:class="'customNormalLabelClass'") {{ strSliceStarAndEndT(node.label, 19, 10, '...') }}
          span(:class="'customRobotNameClass'") {{ node.data.sn }}
        span(v-if="node.data.count", @click="crud({ node, data })") {{ node.data.count }} {{this.$t( "code-lab/view/organization/s-tree.vue_0" ) }}
</template> 

<script>
import toolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { mapState } from 'vuex'
export default {
    name: 'public-tree-component',
    mixins: [ toolMix ],
    props: {
        defaultCheckedKeys: Array,
        data: Array,
    },
    data () {
        return {
            defaultProps: {
                children: 'devices',
                label: 'name'
            }
        }
    },
    computed: {
        ...mapState('rmsConnection', ['rmsDevices']),
        treeData () {
            this.l$(this.data, this.data[0], 'treeData')
            
            return this.handleTreeData(this.data)
        }
    },
    methods: {
        handleTreeData (treeData) {
            let result
            if (treeData.length > 0 && treeData[0].devices) {
                result = treeData.map(mo => ({ count: mo['currentDeviceCount'], devices: mo['devices'], name: mo['groupName'] }))
            } else {
                result = treeData
            }
            console.log(result, this.addId(result))
            return this.addId(result)
        },
        addId (data) {
            data.forEach((fe) => {
                if (fe.devices) fe.devices.forEach(fe => fe.id = fe.deviceId)
            })
            return data
        },
        check (node, check) {
            this.$emit('treeData', { node, check })
            
        },
        // checkChange (data, status) {
            
            
        // },
        // crud (node) {
            
        // },
        // handleNodeClick (data) {
            
        // },
        // currentChange (data, node) {
            
        // }
    }
}
</script>

<style lang="scss">
.caonima {
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 40px;
    align-items: baseline;
    :last-child {
        padding-right: 30px;
        transition: .7s;
    }
}

.customNormalLabelClass {
  font-size: 14px;
  font-weight: 500;
}

.customClassHasId {
    display: flex;
    flex-direction: column;
    line-height: normal;
    padding: 8px 0px 6px 0px;
}
.customRobotNameClass {
    height: 23px;
    line-height: 23px;
    font-size: 12px;
    color: $--codelab-primary-blue-2;
}
.el-tree-node__expand-icon {
    color: #979797;
}
.el-tree {
    background-color:$--codelab-primary-black-2;
    background: $--codelab-primary-black-2;
    color: #ffffff;
}
.public-tree-component {
  .el-tree-node:focus>.el-tree-node__content {
      background-color: $--codelab-primary-black-1;
  }
  .el-icon-caret-right:before {
      content: "\E6E0";
      font-weight: 900;
      font-size: 16px;
  }

  .el-tree-node__content {
      height: auto;
      align-items: baseline;
      &:hover {
          background-color: $--codelab-primary-black-1;
      }
      &::before {
          content: " ";
          margin-left: 20px;
      }
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: transparent;
      border-color: $--codelab-primary-blue-1;
  }
  .el-checkbox__inner:hover {
      border-color: $--codelab-primary-blue-1;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
      height: 4px;
      background-color: $--codelab-primary-blue-1;
  }
  .el-checkbox__inner {
      background-color: transparent;
      border-color: $--codelab-primary-gray-2;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: transparent;
      border-color: $--codelab-primary-blue-1;
  }
  .el-checkbox__input.is-focus  .el-checkbox__inner {
      background-color: transparent;
      border-color: $--codelab-primary-blue-1;
  }

  .el-checkbox__inner::after {
      border-color: $--codelab-primary-blue-1;
  }
  .el-tree-node__content>.el-checkbox {
      margin-left: 15px;
      margin-right: 10px;
  }
}
</style>

